'use strict';
import React, { Component } from 'react';

import { Icon } from 'semantic-ui-react';
interface Menu {
    location: string;
    pageName: string;
    showResidentScroll: boolean;
    icon: Icon;
}
const menus = [
    {
        location: '/activities',
        regex: /^\/activities([\/]|)$/,
        pageName: 'Feed',
        showResidentScroll: true,
        showToManagerOnly: false,

        icon: <Icon name="feed" />,
    },
    {
        location: '/messages',
        pageName: 'Messages',
        showResidentScroll: true,
        showToManagerOnly: false,

        icon: <Icon name="comments" />,
    },
    {
        location: '/reminders',
        pageName: 'Reminders',
        showResidentScroll: true,
        showToManagerOnly: false,
        icon: <Icon name="calendar alternate outline" />,
    },
    {
        location: '/news',
        pageName: 'Send Message',
        showResidentScroll: true,
        showToManagerOnly: false,
        icon: <Icon name="newspaper outline" />,
    },
    {
        location: '/community-activities',
        pageName: 'Community Activities',
        showResidentScroll: false,
        showToCommunityManagerOnly: true,
        icon: <Icon name="paper plane" />,
    },
    {
        location: '/community-menus',
        pageName: 'Community Menus',
        showResidentScroll: false,
        showToCommunityManagerOnly: true,
        icon: <Icon name="food" />,
    },
    {
        location: '/family_friends',
        pageName: 'Friends & Family',
        showResidentScroll: true,
        showToManagerOnly: false,

        icon: <Icon name="group" />,
    },
    {
        location: '/message-recipients',
        pageName: 'Alexa Users',
        showResidentScroll: true,
        showToManagerOnly: false,

        icon: <Icon name="address book" />,
    },
    {
        location: '/settings',
        pageName: 'Settings',
        showResidentScroll: true,
        showToManagerOnly: true,

        icon: <Icon name="book" />,
    },
    {
        location: '/archives',
        pageName: 'Archive',
        showResidentScroll: true,
        showToManagerOnly: true,

        icon: <Icon name="archive" />,
    },
    {
        location: '/payments', 
        pageName: 'Payments', 
        showResidentScroll: true, 
        showToManagerOnly: true,

        icon: <Icon name="credit card" />,
    }
];

export default menus;
